import { render, staticRenderFns } from "./WBtnUnlock.vue?vue&type=template&id=4959475d&scoped=true&"
import script from "./WBtnUnlock.vue?vue&type=script&lang=js&"
export * from "./WBtnUnlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959475d",
  null
  
)

export default component.exports